import { SearchResultCreatorShopPage } from './SearchResultCreatorShop.page.ts';

export const searchResultCreatorShopRouter = {
  '/search': SearchResultCreatorShopPage,
};
